// Yoonly FR overrides — only keys that differ from the regular FR translations.
// Missing keys automatically fall back to the standard 'fr' locale.

const paymentYoonlyFrTranslations = {};

export default paymentYoonlyFrTranslations;
